import React from 'react';

const LoadingSpinner = ({ fullScreen = false, className = '', style = {} }) => {
    const spinnerClasses = `animate-spin rounded-full border-4 border-t-4 border-gray-200 border-t-black ${className || 'h-12 w-12'}`;
    
    if (fullScreen) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className={spinnerClasses} style={style}></div>
            </div>
        );
    }

    return (
        <div className={spinnerClasses} style={style}></div>
    );
};

export default LoadingSpinner; 